<template>
  <vbutton
    class="new-assessment"
    :label="$tr('vacancy.settings.talentq.project-new-block')"
    color="grey"
    type="add"
    @click="$emit('add_assessment')"
  />
</template>

<script>
  export default {
    name: 'NewAssessment'
  };
</script>

<style scoped lang="scss">
  .new-assessment {
    margin: 15px 0;
  }
</style>
